module.exports = __webpack_public_path__ + "static/img/zsbj3.4947c60c.png";